/************************************************************
 Exterior Prescription Namespace
 ************************************************************/

window.exteriorPrescriptionNS = {
    _action: null,
    _callback: null,
    _row: null,

    executeAction: function (action, row, callback) {
        var wfId = parseInt(action.wf_id);
        var actionId = parseInt(action.wf_action_id);

        exteriorPrescriptionNS._action = action;
        exteriorPrescriptionNS._row = row;
        exteriorPrescriptionNS._callback = callback;

        if (actionId == globalConstants.ACTION_CANCEL) {
            exteriorPrescriptionNS.executeGenericActionWithReason();
        }
    },

    executeGenericActionWithReason:function () {
        debug.log('exteriorPrescriptionNS executeGenericActionWithReason: ', exteriorPrescriptionNS._action, exteriorPrescriptionNS._row);
        var params = {
            task_id: exteriorPrescriptionNS._action.task_id,
            wf_id: exteriorPrescriptionNS._action.wf_id,
            wf_status_id: exteriorPrescriptionNS._action.wf_status_id,
            wf_action_id: exteriorPrescriptionNS._action.wf_action_id,

            reason_id: exteriorPrescriptionNS._row.reason_id,
            other_reason: exteriorPrescriptionNS._row.other_reason,
            date: exteriorPrescriptionNS._row.cancel_date,
            hour: exteriorPrescriptionNS._row.cancel_hour
        };


        $.getJSON('/workflow/execute_generic_action_with_reason', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    exteriorPrescriptionNS._callback(false, exteriorPrescriptionNS._action, exteriorPrescriptionNS._row);
                } else {
                    exteriorPrescriptionNS._callback(true, exteriorPrescriptionNS._action, exteriorPrescriptionNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                exteriorPrescriptionNS._callback(false, exteriorPrescriptionNS._action, exteriorPrescriptionNS._row);
            });
    }

}